import request from '@/router/axios'

const problemUrl = '/sg-user-service/v1/certificate'


export function getProblemById(userId) {
  return request({
      url: problemUrl + '/getCertificateDto',
      method: 'get',
      params: {
        userId: userId
      }
  })
}

export function getLoginSSO() {
  return request({
      url: problemUrl + '/getLoginSSO',
      method: 'get',
      params: {}
  })
}



// WEBPACK FOOTER //
// ./src/api/sigen/myCertificate.js